import React, { useState } from 'react';
import AdmVertNav from '../../admincomponents/AdminVertNav/AdmVertNav';
import styles from './SiteAdmins.module.css';
import AdminsComp from '../../admincomponents/AdminsComp/AdminsComp';
import { FiMenu, FiX, FiPlus } from 'react-icons/fi';
import Adminregister from '../Adregist/Adminregister';

const SiteAdmins = () => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [showAdminForm, setShowAdminForm] = useState(false);

  return (
    <div className={styles.siteAdminsContainer}>
      {/* First Column - Main Navigation */}
      <div className={styles.siteAdminsSidebar}>
        <button 
          className="products-mobile-nav-toggle"
          onClick={() => setMobileNavOpen(!mobileNavOpen)}
        >
          {mobileNavOpen ? <FiX size={24} /> : <FiMenu size={24} />}
        </button>

        <AdmVertNav 
          mobileNavOpen={mobileNavOpen} 
          closeMobileNav={() => setMobileNavOpen(false)} 
        />
      </div>
      
      {/* Second Column - Admins List/Component */}
      <div className={styles.siteAdminSecondbar}>
        <div className={styles.adminHeader}>
          <h2>Site Administrators</h2>
          <button 
            className={styles.addAdminButton}
            onClick={() => setShowAdminForm(!showAdminForm)}
          >
            <FiPlus size={20} /> Add Admin
          </button>
        </div>
        <AdminsComp/>
      </div>
      
      {/* Third Column - Admin Registration Form */}
      <div className={`${styles.siteAdminThirdbar} ${showAdminForm ? styles.show : ''}`}>
        <button 
          className={styles.closeButton}
          onClick={() => setShowAdminForm(false)}
        >
          <FiX size={24} />
        </button>
        <Adminregister onClose={() => setShowAdminForm(false)} />
      </div>
    </div>
  );
};

export default SiteAdmins;